import React from 'react'
import { SpaceProps, LayoutProps } from 'styled-system'
import { StyledInput, Label, Wrapper } from './TextAreaStyles'

export interface TextAreaProps extends SpaceProps, LayoutProps {
  name?: string
  id?: string
  value: string
  invalid?: boolean
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
}

export const TextArea: React.FC<TextAreaProps> = ({ id, name, value, children, onChange, invalid, ...props }) => (
  <Wrapper>
    <Label htmlFor={id}>{children}</Label>
    <StyledInput onChange={onChange} id={id} name={name} value={value} invalid={invalid} {...props} />
  </Wrapper>
)
